/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
/*
 * @Author: 张印 hbzyin@163.com
 * @FilePath: /code/mall-fe/src/views/web/product/conponents/RecomendCard/index.tsx
 * @Description: 商品详情页推荐商品卡片
 */
import React, { useState } from 'react';
import useUrl from 'hooks/useUrl';
import { Carousel } from 'antd';
import styles from './index.module.scss';
import { IRecommentProdct, IPriceConfig, ClickRecommendProduct } from '../../product';
const RECOMEND_ARR_LEN = 2;

interface IProps {
  recomendProduct: Array<IRecommentProdct>;
  priceConfig: IPriceConfig;
  onRecommendProductClick: (sku: ClickRecommendProduct) => void;
}
const DescItermCard = (props: {
  data: IRecommentProdct;
  priceConfig: IPriceConfig;
  onClick?: (sku: ClickRecommendProduct) => void;
}) => {
  const { getPublicUrl } = useUrl();
  const { showPrice, tip } = props.priceConfig;
  const [curIndex, setCurIndex] = useState(0);
  const { name, shopName, skuCount, sellCountString, bestSkuSalesPrice, bestSkuSysNo, images } =
    props.data;
  // const goToProductDetail = () => router.push(`/product/detail?id=${bestSkuSysNo}`);

  const handleClick = () => {
    props.onClick?.(props.data);
  };
  return (
    <div className={styles.recomend_item} onClick={handleClick}>
      <img src={getPublicUrl(images[curIndex])} className={styles.product_img_main} />
      <div className={styles.detail_preview}>
        {images.map((src, i) => (
          <div onMouseEnter={() => setCurIndex(i)} key={src} className={styles.preview_img}>
            <img
              src={getPublicUrl(src)}
              className={i === curIndex ? styles.preview_img_item_active : styles.preview_img_item}
            />
          </div>
        ))}
        <div className={styles.product_price}>
          <span>￥</span>
          <span>{showPrice ? bestSkuSalesPrice : tip || '待询价'}</span>
        </div>
        <div className={styles.product_name}>{name}</div>
      </div>
      <div className={styles.prodct_attr}>
        <div>{skuCount}种规格</div>
        <div>销量{sellCountString}</div>
      </div>
      <div className={styles.product_shop}>
        <span className={styles.shop_icon}>
          <i className="iconfont icon-store" />
        </span>
        <span className={styles.shop_name}>{shopName}</span>
      </div>
    </div>
  );
};

const RecomendCard = (props: IProps) => {
  const { recomendProduct = [], onRecommendProductClick } = props;
  const transformArr = (originArr, size) => {
    const res = [];
    let arrItem: IRecommentProdct[];
    originArr.map((item, index) => {
      if (!(index % size)) {
        arrItem = [];
        arrItem.push(item);
        res.push(arrItem);
      }
      if (index % size && index !== 0) {
        if (item) arrItem.push(item);
      }
    });
    return res;
  };

  // 推荐商品数量上限是 6 个
  const getShowRecomentList = () => {
    const totalLen = recomendProduct.length;
    let showLen = 0;
    if (totalLen > 2) showLen = 2 * RECOMEND_ARR_LEN;
    if (totalLen > 4) showLen = 3 * RECOMEND_ARR_LEN;
    return recomendProduct.slice(0, showLen).filter((i) => i);
  };

  return (
    <div className={styles.recomend_container}>
      <div className={styles.recomend_title}>您还可以看看这些</div>
      {!recomendProduct?.length && <div className="no-data">暂无数据</div>}
      {!!recomendProduct?.length && (
        <Carousel dots={{ className: styles.carousel_dot }}>
          {transformArr(getShowRecomentList(), 2).map((arrItem, i) => (
            <div key={i}>
              {arrItem?.map((item) => (
                <DescItermCard
                  key={JSON.stringify(item.bestSkuSysNo)}
                  data={item}
                  priceConfig={props.priceConfig}
                  onClick={onRecommendProductClick}
                />
              ))}
            </div>
          ))}
        </Carousel>
      )}
    </div>
  );
};

export default RecomendCard;
